import React from "react";
import {ColProps, RowProps} from "antd/lib/grid";


export class FormUIConfig {

  noLabels: boolean = false;

  row: RowProps = {
    style: {
      marginBottom: 24
    }
  };

  label: ColProps = {

  };

  control: ColProps = {

  };

}

export const NULL_CONFIG: FormUIConfig = Object.freeze(new FormUIConfig());

export const FormUIConfigContext = React.createContext<FormUIConfig>(NULL_CONFIG);


/*
<Row style={{ marginBottom: removeMargin === true ? '' : 24 }}>
      <Col
        span={labelSpan}
        style={{marginBottom: isTablet || isMobile && labelColSpan === undefined ? '6px' : ''}
      }>
        <label htmlFor={domId}>
          {label}

          {hintText && <TooltipHint style={{marginLeft: '1em'}} hintText={hintText}/>}
        </label>
      </Col>
      <Col span={fieldSpan}>
        <div className={hasErrors && 'has-error'}>{filedImpl}</div>
        {hasErrors ? errors.map(err => <div className='fieldError' key={err}>{err}</div>) : <div className='fieldError' >&nbsp;</div>}
      </Col>
    </Row>
  )
 */

export function buildFormUIConfig(isDesktop: boolean, isTablet: boolean, isMobile: boolean): FormUIConfig {
  const cfg = new FormUIConfig();

  const isTouchscreen = isTablet || isMobile;

  if (isTouchscreen) {
    cfg.label.style = {
      marginBottom: 6
    }
  }
  cfg.label.span = isTouchscreen ? 24 : 4;

  cfg.control.span = isTouchscreen ? 24 : 12;

  return cfg;
}